<div class="w-auto h-150">
   <div class="filters">
    <ng-container>
      <div class="circle-mark-orange"></div>
      <span class="button-filter">Origen</span>
    </ng-container>
    <ng-container>
      <div class="circle-mark-blue"></div>
      <span class="button-filter">Destino</span>
    </ng-container>
   </div>
   <div class="content-percentage">
    <div class="d-flex align-items-center">
      <div >
        <div class="legend-percentage" style="background:rgba(255, 244, 198, 1)"></div>
        <div class="legend-percentage" style="background:rgba(214, 243, 255, 1)"></div>
      </div>
      <span>0% - 10%</span>
    </div>
    <div class="d-flex align-items-center">
      <div >
        <div class="legend-percentage" style="background:rgba(249, 158, 0, 1)"></div>
        <div class="legend-percentage" style="background:rgba(80, 149, 255, 1)"></div>
      </div>
      <span>41% - 50%</span>
    </div>
    <div class="d-flex align-items-center">
      <div >
        <div class="legend-percentage" style="background:rgba(240, 77, 0, 1)"></div>
        <div class="legend-percentage" style="background:rgba(22, 66, 255, 1)"></div>
      </div>
      <span>81% - 90%</span>
    </div>
    <div class="d-flex align-items-center">
      <div >
        <div class="legend-percentage" style="background:rgba(255, 227, 106, 1)"></div>
        <div class="legend-percentage" style="background:rgba(169, 222, 255, 1)"></div>
      </div>
      <span>11% - 20%</span>
    </div>
    <div class="d-flex align-items-center">
      <div >
        <div class="legend-percentage" style="background:rgba(232, 135, 0, 1)"></div>
        <div class="legend-percentage" style="background:rgba(68, 132, 255, 1)"></div>
      </div>
      <span>51% - 60%</span>
    </div>
    <div class="d-flex align-items-center">
      <div >
        <div class="legend-percentage" style="background:rgba(237, 57, 0, 1)"></div>
        <div class="legend-percentage" style="background:rgba(36, 0, 255, 1)"></div>
      </div>
      <span>91% - 100%</span>
    </div>
    <div class="d-flex align-items-center">
      <div >
        <div class="legend-percentage" style="background:rgba(254, 203, 56, 1)"></div>
        <div class="legend-percentage" style="background:rgba(144, 203, 255, 1)"></div>
      </div>
      <span>21% - 30%</span>
    </div>
    <div class="d-flex align-items-center">
      <div >
        <div class="legend-percentage" style="background:rgba(255, 111, 6, 1)"></div>
        <div class="legend-percentage" style="background:rgba(50, 109, 255, 1)"></div>
      </div>
      <span>61% - 70%</span>
    </div>
    <span></span>
    <div class="d-flex align-items-center">
      <div >
        <div class="legend-percentage" style="background:rgba(255, 182, 24, 1)"></div>
        <div class="legend-percentage" style="background:rgba(117, 181, 255, 1)"></div>
      </div>
      <span>31% - 40%</span>
    </div>
    <div class="d-flex align-items-center">
      <div >
        <div class="legend-percentage" style="background:rgba(231, 87, 0, 1)"></div>
        <div class="legend-percentage" style="background:rgba(40, 91, 255, 1)"></div>
      </div>
      <span>71% - 80%</span>
    </div>
    <span></span>
  </div>
</div>
